import ModalForm from 'components/commons/modal-form'
import { InlineError, Input, Switch } from 'avo-ui'
import Select from 'components/commons/select'

export const FormAddress = ({
    show,
    onHide,
    isLoading,
    value,
    onChangeForm,
    errorForm,
    onSubmit,
    addressOptions,
    onSearchAddress,
}) => {
    return (
        <ModalForm
            className={'!w-[650px]'}
            classNameContent={'overflow-auto'}
            show={show}
            onHide={onHide}
            title={'Edit Address'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-6 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Alamat</div>
                    <Select
                        name={'type'}
                        className={'flex-1'}
                        placeholder={'Pilih title'}
                        options={[
                            { label: 'Kantor', value: 'kantor' },
                            { label: 'Rumah', value: 'rumah' },
                            { label: 'Kos', value: 'kos' },
                            { label: 'Lainnya', value: 'lainnya' },
                        ]}
                        value={value?.type}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.type} />
                </div>
                <div className={'grid gap-5 grid-cols-2 gap-x-16 items-start'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Nama Penerima</div>
                        <Input
                            className={'flex-1'}
                            name={'name'}
                            placeholder={'Masukkan nama penerima'}
                            maxLength={60}
                            value={value?.name}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.name} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>No. Telepon Penerima</div>
                        <Input
                            type={'tel'}
                            addonBefore={'+62'}
                            className={'flex-1'}
                            name={'phone_number'}
                            placeholder={'Masukkan no. telepon'}
                            maxLength={14}
                            value={value?.phone_number}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.phone_number} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Kota & Kecamatan</div>
                        <Select
                            name={'detail_address'}
                            className={'flex-1'}
                            placeholder={'Pilih kota & kecamatan'}
                            options={addressOptions.address}
                            value={value?.detail_address}
                            searchable
                            onChange={onChangeForm}
                            onSearch={onSearchAddress}
                            isResetOnSearch={false}
                        />
                        <InlineError className='mt-2' message={errorForm?.detail_address} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Kode Pos</div>
                        <Select
                            name={'zipcode'}
                            className={'flex-1'}
                            placeholder={'Pilih kode pos'}
                            options={addressOptions.zipcode}
                            value={value?.zipcode}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.zipcode} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Alamat Lengkap</div>
                        <Input
                            type={'text-area'}
                            className={'flex-1'}
                            name={'address'}
                            placeholder={'Masukkan Alamat'}
                            row={5}
                            value={value?.address}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.address} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Catatan (Opsional)</div>
                        <Input
                            type={'text-area'}
                            className={'flex-1'}
                            name={'note'}
                            placeholder={'Masukkan Catatan'}
                            row={5}
                            value={value?.note}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.note} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Jadikan Alamat Utama</div>
                        <div className={'flex items-center space-x-2'}>
                            <Switch
                                name={'is_main_address'}
                                checked={value?.is_main_address}
                                onChange={onChangeForm}
                                disabled={value?.is_main_address}
                            />
                            <p className={'font-semibold'}>{!value?.is_main_address && 'Bukan'} Alamat Utama</p>
                        </div>
                        <InlineError className='mt-2' message={errorForm?.is_main_address} />
                    </div>
                </div>
            </div>
        </ModalForm>
    )
}
